import React, { ReactNode } from "react"

import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"

import { ImageOverlayView } from "./ImageOverlayView"

export interface ImageOverlayPayload {
  content?: ReactNode
  url?: string
  title?: string
}

export interface ImageOverlayProps {
  payload: ImageOverlayPayload
}

export const ImageOverlay = React.memo(({ payload }: ImageOverlayProps) => {
  const { closeOverlay } = useCurrentOverlay()

  return (
    <ImageOverlayView
      url={payload.url}
      content={payload.content}
      title={payload.title}
      onClose={closeOverlay}
    />
  )
})

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    IMAGE_OVERLAY: ImageOverlayPayload
  }
}
